import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-listing-page-header',
    templateUrl: './listing-page-header.component.html',
    styleUrls: ['./listing-page-header.component.scss'],
    standalone: false
})
export class ListingPageHeaderComponent implements OnInit {

  @Input() content: any
  constructor() { }

  ngOnInit(): void {
  }

}
